import {
  always,
  assocPath,
  either,
  prop,
} from 'ramda'
import { createSelector } from 'redux-bundler'

import { HARVESTING_FLOW } from '~/src/Flow/constants'
import { EMPTY_OBJECT } from '~/src/Lib/Utils'
import { DEFAULT_NEXT } from '~/src/Routes/constants'

const UPDATE_MY_SETTINGS = 'UPDATE_MY_SETTINGS'

const initState = {
  [HARVESTING_FLOW]: {
    weighingIndividually: true,
    systemUidPerWeight: false,
    weightUnit: { id: null, symbol: '' },
  },
}

export default {
  name: 'userSettings',
  reducer: (state = initState, action = EMPTY_OBJECT) => {
    const { type, payload } = action

    switch (type) {
      case UPDATE_MY_SETTINGS: {
        const { path: settingPath, value } = payload
        return {
          ...state,
          ...assocPath(settingPath, value, { ...state }),
        }
      }
      default: {
        return state
      }
    }
  },
  doUpdateMySettings: payload => ({ type: UPDATE_MY_SETTINGS, payload }),
  selectMySettings: state => state.userSettings || EMPTY_OBJECT,
  selectHarvestingFlowSettings: createSelector(
    'selectMySettings',
    // if harvesting flow settings are not set, return empty object
    either(prop(HARVESTING_FLOW), always(EMPTY_OBJECT)),
  ),
  selectLandingPage: createSelector(
    'selectMySettings',
    mySettings => mySettings.landingPage || DEFAULT_NEXT,
  ),
  persistActions: [
    UPDATE_MY_SETTINGS,
  ],
}
